module.exports = __webpack_public_path__ + "img/outcomes.a8dd21e3.png";